module.exports = __webpack_public_path__ + "static/media/Team 25 - Octopus - Boon Mys.08ee08f4.png";